export default "__VITE_ASSET__DbEsrz7F__"